// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__b9mHA","modalFooterButton":"ModalNotes_modalFooterButton__2GscK"};